// extracted by mini-css-extract-plugin
export default {"label":"OBy_rIgLaNM2u76UuPDe","form-group":"m8nCU6Kk_S1quzxQMOpa","formGroup":"m8nCU6Kk_S1quzxQMOpa","actions":"YGk1CxsunmaOKu7pvujg"};